export default function log(tag, bgColor, msg: string, ...args) {
  if (typeof process !== "undefined") return
  console.log(
    `%c%s%c %s`,
    `background-color: ${bgColor}; font-weight: bold; color: #222; padding: 2px; padding-left: 4px; padding-right: 4px; border-radius: 2px;`,
    tag,
    `background-color: none;`,
    msg,
    ...args
  )
}
